
import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from '../../..//assets/Player_Portal/images/logoImg.png'
import { Link, useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import userImage from '../../../assets/Admin_Portal/images/userImage.png'
import styled from 'styled-components';


const UserName = styled.p`
line-height: 15px;
text-align: start;
font-family: 'Poppins';
font-weight: 500;
width: 170px;
color: #fff;
margin-left: 20px !important;
`
const UserRole = styled.span`
font-size: 10px;
color: #999999;
`




export const Navbars = () => {
  const navigate = useNavigate()
  const userName = localStorage.getItem("userName")
  const logoutButton = () => {

    // console.log("CLick hora")
    localStorage.clear();
    navigate('/login')
  }

  return (
    <Navbar expand="lg" className="bg-body-tertiary navBarCstm">
      <Container fluid>
        <Link to="/"><img src={Logo} alt="Logo" /></Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {/* <Nav.Link href="/">Home</Nav.Link> */}
            <Nav.Link as={Link} to="/"> Home </Nav.Link>
            <Nav.Link as={Link} to="/about">About</Nav.Link>
            <Nav.Link as={Link} to="/game">Games</Nav.Link>
            <Nav.Link as={Link} to="/about">Blog</Nav.Link>
            <Nav.Link as={Link} to="/about">Contact</Nav.Link>
            {!userName ?
              <>
                <Nav.Link as={Link} to="/login" className='btnLogin'>Login</Nav.Link>
                <Nav.Link as={Link} to="/signup" className='btnSignup'>Signup</Nav.Link>
              </>

              :
              <Dropdown>
      <Dropdown.Toggle className='d-flex align-items-center shadow-none' variant="muted" id="dropdown-basic">
        <img src={userImage} className='img-fluid' alt="User Image"/>
        <UserName className='mx-3 mb-0'>{userName} <br/> 
        <UserRole>Admin</UserRole></UserName></Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#/action-1">Profile</Dropdown.Item>
        <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
        <Dropdown.Item><Link as={Link} to="/login" className='text-decoration-none text-dark d-block' onClick={logoutButton}>Logout</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
            }

          </Nav>
        </Navbar.Collapse>


      </Container>
    </Navbar>
  );
}


{/* <Nav.Link as={Link} to="/login" className='btnLogin' onClick={logoutButton}>Logout</Nav.Link> */}